<template>
  <div class="spinner-container">
    <div class="loading-spinner rounded shadow-sm">
      <div class="spinner-border spinner-border-sm me-2"></div>
      <span>{{ text || "Loading..." }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["text"],
  mounted() {
    document.body.classList.add("overflow-hidden");
  },
  beforeDestroy() {
    document.body.classList.remove("overflow-hidden");
  },
};
</script>

<style>
.spinner-container {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 2000;
  background-color: #000000be;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  padding: 2rem;
  background-color: #ffffff;
  color: #000000;
  width: fit-content;
}
</style>